import type { PropertyCriteria } from './propertyCriteria'
import { SearchCriteria } from './searchOperator'
import type { SearchSort } from './searchSort'

export enum SearchModelEnum {
  offset = 'offset',
  limit = 'limit',
  freeText = 'freeText',
  objectIds = 'objectIds',
  mediaIds = 'mediaIds',
  createdByIds = 'createdByIds',
  createdRange = 'createdRange',
  updatedByIds = 'updatedByIds',
  updatedRange = 'updatedRange',
  uploadedByIds = 'uploadedByIds',
  uploadedRange = 'uploadedRange',
  mediaStatusIds = 'mediaStatusIds',
  folderIds = 'folderIds',
  folderDepth = 'folderDepth',
  moodboardIds = 'moodboardIds',
  categoryIds = 'categoryIds',
  ignoreGrouping = 'ignoreGrouping',
  includeChildren = 'includeChildren',
  parentId = 'parentId',
  deploymentSiteIds = 'deploymentSiteIds',
  deploymentSiteCriteria = 'deploymentSiteCriteria',
  properties = 'properties',
  propertyCriteria = 'propertyCriteria',
  fileSizeCriteria = 'fileSizeCriteria',
  widthCriteria = 'widthCriteria',
  durationCriteria = 'durationCriteria',
  heightCriteria = 'heightCriteria',
  mimeTypes = 'mimeTypes',
  fileName = 'fileName',
  name = 'name',
  deploymentDateRange = 'deploymentDateRange',
  sortFields = 'sortFields',
  duplicates = 'duplicates',

  //Indicate all criteria should be removed
  // all = 'all'
}

export type SearchModel = {
  offset?: number,
  limit?: number,
  freeText?: string,
  objectIds?: number[],
  mediaIds?: number[],
  createdByIds?: number[],
  createdRange?: string[],
  updatedByIds?: number[],
  updatedRange?: string[],
  uploadedByIds?: number[],
  uploadedRange?: string[],
  mediaStatusIds?: number[],
  folderIds?: number[],
  folderDepth?: number,
  moodboardIds?: number[],
  categoryIds?: number[],
  ignoreGrouping?: boolean,
  includeChildren?: boolean,
  parentId?: number,
  deploymentSiteIds?: number[],
  deploymentSiteCriteria? : SearchCriteria,
  properties?: PropertyCriteria[],
  propertyCriteria?: any,
  fileSizeCriteria?: string[],
  widthCriteria?: string[],
  durationCriteria?: string[],
  heightCriteria?: string[],
  mimeTypes?: string[],
  fileName?: string,
  name?: string,
  deploymentDateRange?: string[],
  sortFields?: SearchSort[] | string[],
  duplicates?: boolean,

  //Labels can be stored and accessed through "labels > [searchCriteria] > [value.toString()] > [label]
  labels?: { [key: string]: { [key: string]: string } }
}
